import * as React from "react";
import clsx from "clsx";
const Pebble = ({ size, theme, className }) => {
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: clsx(
        "pebble",
        {
          ["pebble--".concat(size)]: !!size,
          ["pebble--".concat(theme)]: !!theme
        },
        className
      )
    }
  );
};
export {
  Pebble
};
